var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"images-loaded",rawName:"v-images-loaded",value:(_vm.onLoaded),expression:"onLoaded"}],class:_vm.classes,attrs:{"src":_vm.normalizedSrc,"alt":_vm.renderedTitle,"title":_vm.renderedTitle}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17d174fe","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/snippets/Bitmap.vue
// module id = null
// module chunks = 